module.exports = __webpack_public_path__ + "static/fcra-2016-17-q2-0e371caa262f8f05f3a7ae1c08b4b991.pdf";